import { ReportHour } from "./ReportHour";

export class ReportDay{

    date:string;
    hours:Array<ReportHour>

    constructor(date:string,hours:Array<ReportHour>){
        this.date = date;
        this.hours = hours;
    }
}


// WEBPACK FOOTER //
// ./src/app/DataStructures/Report/ReportDay.ts